import React, { useMemo } from 'react';
import * as Utils from '../../services/utils';

const Timestamp = ({ }) => {
    const memoizedTimeQ = useMemo(() => Utils.getTime(), []);  
    return (
       <>{memoizedTimeQ}</>
    );
}
export default  Timestamp;